import Uppy, { Meta } from '@uppy/core';
import XHRUpload from '@uppy/xhr-upload';
import { encryptFile } from 'features/e2ee/utils/encryptFile';
import { uploadProgressChanged } from 'features/whiteboard/whiteboardSlice';
import { store as reduxStore } from 'store/store';
import { RTCClient } from 'utils/webrtc';

export type UppyBody = {
  link: string;
};

const MAX_UPLOAD_FILE_SIZE = 10 * 1024 * 1024;

export const createWbImageUploader = (token: string): Uppy<Meta, UppyBody> => {
  const uploader = new Uppy<Meta, UppyBody>({
    restrictions: { maxFileSize: MAX_UPLOAD_FILE_SIZE },
    autoProceed: false,
    onBeforeFileAdded: () => true,
  });

  uploader.use(XHRUpload, {
    endpoint: `${process.env.REACT_APP_API_URL}/room-api/${RTCClient.roomId}/files/upload`,
    formData: true,
    fieldName: 'file',
    headers: { authorization: `Bearer ${token}` },
  });

  uploader.on('progress', (progress) => {
    reduxStore.dispatch(uploadProgressChanged(progress));
  });

  return uploader;
};

export const addImageFileToUploader = async (
  uploader: Uppy<Meta, UppyBody>,
  file: File,
  encryptionKey?: CryptoKey
): Promise<void> => {
  if (encryptionKey) {
    const fileBuffer = await file.arrayBuffer();
    const encryptedBlob = await encryptFile(fileBuffer, encryptionKey, file.type);
    uploader.addFile({ name: file.name, type: 'wb-image', data: encryptedBlob });
    return;
  }

  uploader.addFile({ name: file.name, type: 'wb-image', data: file });
};
